import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { ComponentsSlider } from "../../ComponentsSlider";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../../sharedComponents/Link";
import { AngleRight } from "../../../sharedComponents/Images";
import { CardsContainerGrid } from "../Grid";
import { RCL as useTranslation } from "../../RCL";
import * as styles from "./CardsContainerSlide.module.scss";

const CardsContainerSlide = ({
	children,
	link,
	breakpoints,
	id,
	paginationClasses,
	paging,
	slidesPerPage,
}) => {
	const slides = React.Children.map(children, component => ({
		id: component.props.id,
		view: component,
	}));
	const loadAllLabel = useTranslation({ searchKey: "load-all" });
	const loadMoreLabel = useTranslation({ searchKey: "load-more" });
	return (
		<div className={styles.sliderContainer}>
			{slides.length > 1 ? (
				<ComponentsSlider
					slides={slides}
					link={link}
					breakpoints={breakpoints}
					navigation="desktopOnly"
					paging={paging}
					linkIcon={true}
					id={id}
					cardSlider={true}
					paginationClasses={paginationClasses}
					slidesPerPage={slidesPerPage}
				/>
			) : (
				<>
					<CardsContainerGrid
						labels={{
							loadAll: loadAllLabel,
							loadMore: loadMoreLabel,
						}}>
						{children}
					</CardsContainerGrid>
					{!!link && (
						<Link to={link.urlLink} className={styles.slideGridViewLink}>
							{link.linkText}
							<AngleRight />
						</Link>
					)}
				</>
			)}
		</div>
	);
};

CardsContainerSlide.propTypes = {
	children: PropTypes.arrayOf(PropTypes.node).isRequired,
	link: PropTypes.object,
	breakpoints: PropTypes.object,
	id: PropTypes.string,
	paginationClasses: PropTypes.shape({
		pagination: PropTypes.string,
		bullet: PropTypes.string,
		bulletActive: PropTypes.string,
		autoplay: PropTypes.string,
	}),
	paging: PropTypes.oneOf([true, false, "desktopOnly"]),
	slidesPerPage: PropTypes.oneOf([1, 2, 3, 4]),
};
CardsContainerSlide.defaultProps = {
	link: null,
	breakpoints: null,
	slidesPerPage: 3,
	id: null,
	paginationClasses: null,
	paging: true,
};

export default CardsContainerSlide;
export { CardsContainerSlide };
